// services/authService.js

import api from './api';

export const login = async (email, password) => {
  try {
    const response = await api.post('/login', { email, password });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const register = async (user) => {
    try {
      const response = await api.post('/register', user);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };

  export const verifyOTP = async (email,otp) => {
    try {
      const response = await api.post('/verify', { email, otp });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };


  export const forgotPassword = async (email) => {
    try {
        const response = await api.post('/password/email', { email });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const resetPassword = async (email, password, token) => {
    try {
        const response = await api.post('/reset-password', { email, password, token });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};